<template>
<div class="chapter">
<div class="inner_page">
<section>
<h2><span class="h2-inner">2</span></h2>
<p class="firstInSection">Eve Anders looked out of the aircraft’s round window and saw the ground drop away below.</p>
<p>She had mixed feelings about going home. Leaving the children hadn’t been easy, but she had to be sensible. She was no mother substitute for them, never would be. Jess Lavender, with her large family, would fill that role.</p>
<p>Here she was again, elated at the thought that she had been persuaded to get back into the struggle for democracy.</p>
<p>There had been times when Eve felt that she’d had democracy up to here.</p>
<p>Democracy and justice existed like things frail and sick, things that couldn’t be left to take care of themselves. They prodded you and banged on the floor. Attend to me!</p>
<p>Why listen when nothing changed?</p>
<p>At fourteen she had hammered on her head teacher’s door and said, It’s not fair what you’ve done. It hadn’t been fair, but nothing had changed.</p>
<p>At seventeen, she had stood in front of a crowd of workers and said, It’s not fair the way factory girls are treated. It hadn’t been fair, but the girls had been intimidated; they retreated so that, again, nothing had changed.</p>
<p>Then Spain – so much misery, so much blood and death, such a lot of orphans and widows, such great numbers of maimed men – all that, yet still democracy in Spain had died. Dead as mutton.</p>
<p>And now her own country had invited her to jump through the same hoop. Attend to me!</p>
<p>She had been thrilled to bits when David Hatton had made contact with her. A special unit was being formed. It was in need of women. Too hush-hush to talk about on the telephone. He absolutely knew for sure that she would revel in this new work.</p>
<p>‘You know that I would never leave here without Dimitri.’</p>
<p>He’d said that he thought that could be arranged.</p>
<p>She knew all this was bait to her curiosity, but she was ready to go home, so she took the bait.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter4.vue?3311b9c0